import React from 'react';

import {Analytics} from '../../../services/analytics';
import {JobInfo} from './jobUtil';
import * as S from './PublicJobCard.styles';

export interface PublicJobCardProps {
  job: JobInfo;
  onLaunch: () => void;
}

export const PublicJobCard: React.FC<PublicJobCardProps> = ({
  job,
  onLaunch,
}) => {
  const handleCardClick = () => {
    Analytics.track('clicked public job card', {
      jobId: job.id,
      location: 'zero jobs page',
    });

    onLaunch();
  };

  return (
    <S.JobCard onClick={handleCardClick} style={{cursor: 'pointer'}}>
      <S.FlashIconContainer>
        <S.FlashIcon name="flash-bolt" />
      </S.FlashIconContainer>
      <S.JobContent>
        <S.JobName>{job.name}</S.JobName>
        <S.JobDescription>{job.description}</S.JobDescription>
      </S.JobContent>
      <div onClick={e => e.stopPropagation()}>
        <S.LaunchButton
          onClick={onLaunch}
          role="button"
          aria-label="Open launch drawer">
          <S.LaunchIcon name="play" />
        </S.LaunchButton>
      </div>
    </S.JobCard>
  );
};
